/*
  NAAMANE snelheid en batterij (1-11).
  - Live vervaagde achtergrondfoto's (CSS blur op grote foto's) worden op telefoons één keer
    vooraf vervaagd in een piepklein plaatje. Zelfde look, bijna geen GPU-werk meer.
  - Secties buiten beeld krijgen .nm-off (animaties pauzeren), de hero-slider pauzeert buiten beeld
    en als het tabblad op de achtergrond staat.
  - Regen op de raincoat-slide als aparte laag (zie naamane-perf.css).
*/
(() => {
  if (window.__nmPerf) return;
  window.__nmPerf = true;
  const html = document.documentElement;
  const isFirefox = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-moz-appearance', 'none');
  const small = window.matchMedia('(max-width: 989px), (pointer: coarse)');

  /* ---------- vooraf vervagen ---------- */
  const BLUR_SEL = 'img.nm-hc__bg-img, .nm-looks__bg img';
  const cache = new Map();
  const tiny = (url, w) => url.replace(/([?&])width=\d+/, `$1width=${w}`) + (/[?&]width=/.test(url) ? '' : (url.includes('?') ? '&' : '?') + `width=${w}`);
  const parse = (f) => [...String(f).matchAll(/([a-z-]+)\(([^)]*)\)/g)].map((m) => [m[1], parseFloat(m[2]) * (m[2].includes('%') ? 0.01 : 1)]);
  const clamp = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const colorOps = (d, ops) => {
    for (let i = 0; i < d.length; i += 4) {
      let r = d[i] / 255, g = d[i + 1] / 255, b = d[i + 2] / 255;
      for (const [fn, a] of ops) {
        if (fn === 'brightness') { r *= a; g *= a; b *= a; }
        else if (fn === 'contrast') { r = (r - 0.5) * a + 0.5; g = (g - 0.5) * a + 0.5; b = (b - 0.5) * a + 0.5; }
        else if (fn === 'grayscale') {
          const k = 1 - Math.min(1, a);
          const nr = (0.2126 + 0.7874 * k) * r + (0.7152 - 0.7152 * k) * g + (0.0722 - 0.0722 * k) * b;
          const ng = (0.2126 - 0.2126 * k) * r + (0.7152 + 0.2848 * k) * g + (0.0722 - 0.0722 * k) * b;
          const nb = (0.2126 - 0.2126 * k) * r + (0.7152 - 0.7152 * k) * g + (0.0722 + 0.9278 * k) * b;
          r = nr; g = ng; b = nb;
        } else if (fn === 'saturate') {
          const s = a;
          const nr = (0.213 + 0.787 * s) * r + (0.715 - 0.715 * s) * g + (0.072 - 0.072 * s) * b;
          const ng = (0.213 - 0.213 * s) * r + (0.715 + 0.285 * s) * g + (0.072 - 0.072 * s) * b;
          const nb = (0.213 - 0.213 * s) * r + (0.715 - 0.715 * s) * g + (0.072 + 0.928 * s) * b;
          r = nr; g = ng; b = nb;
        } else continue;
        r = clamp(r); g = clamp(g); b = clamp(b);
      }
      d[i] = r * 255; d[i + 1] = g * 255; d[i + 2] = b * 255;
    }
  };
  /* 3x box blur ~ gaussian, randen vastgehouden */
  const boxBlur = (d, w, h, sigma) => {
    if (sigma < 0.4) return;
    const r = Math.max(1, Math.round(Math.sqrt((12 * sigma * sigma) / 3 + 1) / 2));
    const tmp = new Float32Array(d.length);
    const pass = (src, dst, horiz) => {
      const len = horiz ? w : h, lines = horiz ? h : w;
      for (let l = 0; l < lines; l++) {
        for (let c = 0; c < 4; c++) {
          let acc = 0;
          const at = (p) => { const q = p < 0 ? 0 : p >= len ? len - 1 : p; return horiz ? (l * w + q) * 4 + c : (q * w + l) * 4 + c; };
          for (let p = -r; p <= r; p++) acc += src[at(p)];
          for (let p = 0; p < len; p++) {
            dst[at(p)] = acc / (2 * r + 1);
            acc += src[at(p + r + 1)] - src[at(p - r)];
          }
        }
      }
    };
    for (let k = 0; k < 3; k++) { pass(d, tmp, true); pass(tmp, d, false); }
  };
  const bakeUrl = (url, filter, dispW) => {
    const key = url + '|' + filter + '|' + Math.round(dispW / 50);
    if (cache.has(key)) return cache.get(key);
    const p = new Promise((resolve, reject) => {
      const ops = parse(filter);
      const blur = (ops.find((o) => o[0] === 'blur') || [0, 0])[1];
      const w = Math.max(16, Math.min(64, Math.round(dispW / Math.max(4, blur / 1.6))));
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = () => {
        try {
          const h = Math.max(8, Math.round((w * im.naturalHeight) / (im.naturalWidth || 1)));
          const c = document.createElement('canvas');
          c.width = w; c.height = h;
          const ctx = c.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(im, 0, 0, w, h);
          const data = ctx.getImageData(0, 0, w, h);
          const f = new Float32Array(data.data);
          boxBlur(f, w, h, (blur * w) / Math.max(1, dispW));
          colorOps(f, ops);
          for (let i = 0; i < f.length; i++) data.data[i] = f[i];
          ctx.putImageData(data, 0, 0);
          resolve(c.toDataURL('image/png'));
        } catch (e) { reject(e); }
      };
      im.onerror = reject;
      im.src = tiny(url, 160);
    });
    cache.set(key, p);
    p.catch(() => cache.delete(key));
    return p;
  };
  const baseUrl = (img) => {
    const s = img.getAttribute('src') || '';
    if (!s || s.startsWith('data:')) return '';
    return new URL(s, location.href).href;
  };
  const bake = (img) => {
    const url = baseUrl(img);
    if (!url) return;
    if (img.dataset.nmBaked === url) return;
    /* eerst terug naar de echte CSS-blur, zodat er nooit een scherpe foto te zien is */
    img.style.removeProperty('content');
    img.style.removeProperty('filter');
    if (!img.dataset.nmFilter) {
      const f = getComputedStyle(img).filter;
      if (!f || f === 'none' || !/blur/.test(f)) return;
      img.dataset.nmFilter = f;
    }
    img.dataset.nmBaked = url;
    const dispW = img.getBoundingClientRect().width || img.parentElement.getBoundingClientRect().width || 400;
    bakeUrl(url, img.dataset.nmFilter, dispW).then((data) => {
      if (img.dataset.nmBaked !== url) return; /* intussen andere foto */
      img.style.setProperty('content', `url("${data}")`);
      img.style.setProperty('filter', 'none', 'important');
    }).catch(() => { delete img.dataset.nmBaked; });
  };
  /* vaste hero-achtergronden: meteen een klein bestand laden in plaats van 500px */
  const shrinkHc = (img) => {
    if (img.dataset.nmSmall) return;
    img.dataset.nmSmall = '1';
    const s = img.getAttribute('src');
    if (!s || s.startsWith('data:')) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', tiny(s, 160));
  };
  const runBlur = () => {
    if (isFirefox || !small.matches) return;
    document.querySelectorAll('img.nm-hc__bg-img').forEach(shrinkHc);
    document.querySelectorAll(BLUR_SEL).forEach(bake);
  };

  /* ---------- regen als aparte laag ---------- */
  const rain = () => {
    document.querySelectorAll('.nm-hero__slide[href*="raincoat"]').forEach((slide) => {
      if (slide.querySelector(':scope > .nm-rainfx')) return;
      const fx = document.createElement('span');
      fx.className = 'nm-rainfx';
      fx.setAttribute('aria-hidden', 'true');
      fx.append(document.createElement('i'));
      slide.prepend(fx);
    });
  };

  /* ---------- pauzeren buiten beeld ---------- */
  const heroes = new Set();
  const setHero = (hero, on) => {
    if (!hero || typeof hero.schedule !== 'function') return;
    if (on && !document.hidden) {
      if (hero.__nmOff) { hero.__nmOff = false; hero.paused = false; hero.schedule(); }
    } else if (!hero.__nmOff) {
      hero.__nmOff = true; hero.paused = true; clearTimeout(hero._t);
    }
  };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      e.target.classList.toggle('nm-off', !e.isIntersecting);
      e.target.querySelectorAll('nm-hero').forEach((h) => { heroes.add(h); setHero(h, e.isIntersecting); });
    });
  }, { rootMargin: '120px 0px' }) : null;
  const watched = new WeakSet();
  const watch = () => {
    if (!io) return;
    document.querySelectorAll('.shopify-section').forEach((s) => {
      if (watched.has(s)) return;
      watched.add(s);
      /* nooit pauzeren waar een lade of popup in zit: die openen in de bovenste laag en hun animatie moet altijd lopen */
      if (s.querySelector('dialog, [role="dialog"], details-modal, cart-drawer-component')) return;
      io.observe(s);
    });
  };
  document.addEventListener('visibilitychange', () => {
    html.classList.toggle('nm-hidden', document.hidden);
    heroes.forEach((h) => {
      const sec = h.closest('.shopify-section');
      setHero(h, !document.hidden && !(sec && sec.classList.contains('nm-off')));
    });
  });

  /* telefoon: hero een rondje laten draaien en dan stoppen op de eerste slide (1-11, minder warmte).
     Vegen en de puntjes blijven werken, alleen het automatisch doorlopen stopt. Regen staat dan stil. */
  const reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const tameHero = (hero) => {
    if (hero.__nmTame || !small.matches || typeof hero.schedule !== 'function' || !hero.slides || hero.slides.length < 2) return;
    hero.__nmTame = true;
    hero.__nmShown = 1;
    hero.schedule = function () {
      clearTimeout(this._t);
      if (this.__nmDone || this.paused || !this.delay || reducedMq.matches) return;
      this._t = setTimeout(() => {
        this.__nmShown += 1;
        if (this.__nmShown > this.slides.length) {
          this.__nmDone = true;
          this.classList.add('nm-hero--done');
          this.go(0);
          this.querySelectorAll('.nm-rainfx > i').forEach((i) => { i.style.animationPlayState = 'paused'; });
        } else {
          this.go(this.index + 1);
        }
      }, this.delay);
    };
    hero.schedule();
  };
  const tameAll = () => document.querySelectorAll('nm-hero').forEach(tameHero);
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('nm-hero').then(() => setTimeout(tameAll, 0));

  const all = () => { rain(); watch(); runBlur(); tameAll(); };
  const start = () => {
    all();
    /* nieuwe foto's in de looks-achtergrond en secties die later geladen worden */
    let q = false;
    new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && m.target.matches && m.target.matches(BLUR_SEL)) {
          if (!isFirefox && small.matches) bake(m.target);
        }
      }
      if (q) return;
      q = true;
      requestAnimationFrame(() => { q = false; all(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    if (small.addEventListener) small.addEventListener('change', runBlur);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
